// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1RJ2i","upload":"Small_upload__j8kns","imageWrap":"Small_imageWrap__15OZb","removeBtn":"Small_removeBtn__yw-NE"};